import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Promotion } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { AccountManagementEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import moment from 'moment';
import { CountryCode } from '@/store/ui';
import { getCountryByHostname } from '@/helpers/country';

@Component({
  name: 'CmgMemberRewardItem',
})
export default class CmgMemberRewardItem extends Vue {
  isLoading = false;
  dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

  @Prop({ required: true, default: false, type: Object })
  reward!: Promotion;

  get countryCode(): string {
    const countryProfile = getCountryByHostname(window.location.hostname);
    return countryProfile.countryCode;
  }

  loyaltyString(): string {
    switch (this.countryCode) {
      case CountryCode.GB:
        return 'offer';
      default:
        return 'reward';
    }
  }

  get defaultRewardChili(): string {
    return this.$appStore.state.cms.images.icons.defaultRewardChili.default;
  }

  get expirationDate(): string {
    let rewardDate = this.countryCode === CountryCode.GB ? moment(this.reward.expirationDate).format('DD/MM/YYYY') : moment(this.reward.expirationDate).format('MM/DD/YYYY');

    return rewardDate;
  }

  get buttonText(): string {
    const order = this.$services.order.getCurrentOrder();
    if (!order || !order.discounts || !order.discounts.find(d => d.promotionCode === this.reward.promotionCode)) {
      return 'ADD TO BAG';
    } else {
      if (this.$appStore.state.ui.clientWidth >= 768) {
        return 'REMOVE FROM BAG';
      }
      return 'REMOVE';
    }
  }

  onTerms(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('rewardTermsAndConditions', true, { termsAndConditions: this.reward.termsAndConditions });
    this.$services.ui.firstFocus();
  }

  onScan() {
    this.$services.ui.setModalVisibility('rewards', true, {
      selectedReward: this.reward
    });
  }

  async onAddToBag(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: this.reward.promotionName + AnalyticsEventAction.RewardToBag,
      label: AnalyticsEventLabel.RewardToBag + this.reward.promotionName,
    });

    this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.RewardsAddedToBag, undefined, this.reward.promotionName, 'Rewards Wallet'));

    this.isLoading = true;
    await this.$services.reward.addPromotionToBag(this.reward);
    this.isLoading = false;
  }
}
